module.exports = __webpack_public_path__ + "static/img/mag-float.701a7c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mag-float.png
// module id = PtKy
// module chunks = 1